import type { SVGProps } from 'react';

const Fire = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.1666 9.33332C12.1666 12 10.3333 12.8333 7.99994 12.8333C5.33334 12.8333 3.83334 10.9333 3.83334 9.33332C3.83334 7.73332 4.66667 6.27777 5.33334 5.83332C5.33334 7.69999 7.11107 8.88886 7.99994 8.83332C6.39996 6.43332 7.77774 3.77777 8.6666 3.16666C8.6666 6.16666 12.1666 6.66666 12.1666 9.33332Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Fire;
